export default {
  label: "label",
  summary: "summary",
  type: "type",
  color: "color",
  start: "start",
  duration: "duration",
  end: "end"
};

export const syncLocalFieldNames = {
  label: "Label",
  summary: "Summary",
  type: "Type",
  color: "Color",
  start: "Start Date",
  duration: "Duration",
  end: "End Date"
};
